import { useEffect, useMemo } from 'react'

import { useResize } from 'reactUtils/hooks/use-resize'
import { useScrollDirection } from 'reactUtils/hooks/use-scroll-direction'

import { useProfile } from 'catalog/hooks/use-profile'

const Wrapper = ({ breadcrumbRef, children }) => {
  const { profile } = useProfile()
  const [isMobile] = useResize(992)
  const [direction, scrollY] = useScrollDirection()

  const isOnMobileApp = useMemo(
    () => profile.context === 'app' || !Object.keys(profile).length,
    [profile]
  )

  const header = useMemo(() => document.querySelector('[data-new-header]'), [])
  const headerHeight = useMemo(() => header?.offsetHeight, [header])

  const isLowerThanHeaderHeight = useMemo(() => scrollY > headerHeight, [
    headerHeight,
    scrollY
  ])
  const isAtTop = useMemo(() => scrollY === 0, [scrollY])

  useEffect(() => {
    if (isOnMobileApp) {
      return
    }

    if (!isMobile) {
      header.classList.remove('sticky')

      return
    }

    header.classList.add('sticky')

    return () => header.classList.remove('sticky')
  }, [header, isMobile, isOnMobileApp])

  useEffect(() => {
    if (isOnMobileApp) {
      return
    }

    if (!isMobile) {
      header.style.top = 0

      return
    }

    const breadcrumb = breadcrumbRef.current
    const shouldHideHeader = direction === 'down' || isAtTop
    const shouldShowHeader = direction === 'up' && isLowerThanHeaderHeight

    if (shouldHideHeader) {
      header.style.top = `-${headerHeight}px`
      breadcrumb && (breadcrumb.style.top = 0)
    }

    if (shouldShowHeader) {
      header.style.top = 0
      breadcrumb && (breadcrumb.style.top = `${headerHeight}px`)
    }
  }, [
    direction,
    headerHeight,
    isLowerThanHeaderHeight,
    isAtTop,
    header,
    breadcrumbRef,
    isMobile,
    isOnMobileApp
  ])

  return children
}

export default Wrapper
